export class ProspectContactRequest {
  called?: boolean;
  doorNocked?: boolean;
  sms?: boolean;
  noAnswer?: boolean;
  note?: string;
  calledPhoneNumber?: string;
  smsPhoneNumber?: string;
}
